export default {
  BLOCK_SELECTOR: 'block-selector',
  LAYOUT_SWITCHING: 'layout-switching',
};
